import React from 'react';
import './SourceCard.css';
import { Source } from '../../../types/Source';

export interface Props {
  source: Source;
}

function SourceCard({ source }: Props): JSX.Element {
  // Function to extract YouTube video ID
  const getYouTubeEmbedUrl = (url: string | null): string | null => {
    if (!url) return null;
    try {
      const parsedUrl = new URL(url);
      if (
        parsedUrl.hostname.includes('youtube.com') ||
        parsedUrl.hostname.includes('youtu.be')
      ) {
        const videoId = parsedUrl.hostname.includes('youtu.be')
          ? parsedUrl.pathname.substring(1) // Extract video ID from youtu.be link
          : parsedUrl.searchParams.get('v'); // Extract video ID from youtube.com/watch?v= link

        return videoId ? `https://www.youtube.com/embed/${videoId}` : null;
      }
    } catch (error) {
      console.error('Invalid YouTube URL:', url);
    }
    return null;
  };

  const embedUrl = getYouTubeEmbedUrl(source.sourceUrl);

  return (
    <div className="SourceCardContainer">
      {embedUrl && (
        <div className="SourceCardEmbedContainer">
          <iframe src={embedUrl} allowFullScreen title={source.sourceTitle} />
        </div>
      )}
      <div className="video-heading-wrap">
        <div className="video-title-section">
          <a
            href={source.sourceUrl ? source.sourceUrl : undefined}
            target="_blank"
            rel="noopener noreferrer"
            className="SourceCardLinkText"
          >
            {source.sourceTitle}
          </a>
        </div>
      </div>
    </div>
  );
}

export default SourceCard;
